import { exportarCsv } from 'utilities/csv.util'
import { Transfer, TransferStatus } from './types'
import { getProcedureDescription } from './transferStatus'

/**
 * Exports transfers to CSV. Columns depend on the status being viewed,
 * matching the detail table.
 */
export const downloadTransfersCsv = (
  transfers: Transfer[],
  selectedStatus: TransferStatus
) => {
  const isPaidReport = selectedStatus === TransferStatus.PAGO
  const isPendingReport = selectedStatus === TransferStatus.PENDENTE

  let csv: string
  if (isPaidReport) {
    csv =
      'Atendimento;Status;Convenio;Procedimento;Data do procedimento;Data da Alta;Data do fechamento;Data do pagamento;Valor\n'
  } else if (isPendingReport) {
    csv =
      'Atendimento;Status;Convenio;Procedimento;Data do procedimento;Data da Alta;Data Protocolo;Classe do título;Status glosa título;Valor\n'
  } else {
    csv =
      'Atendimento;Status;Convenio;Procedimento;Data do procedimento;Data da Alta;Data Protocolo;Valor\n'
  }

  transfers.forEach((t) => {
    csv += t.numeroAtendimento === null ? 'N/A;' : t.numeroAtendimento + ';'
    csv += t.status + ';'
    csv += t.descricaoConvenio + ';'
    csv += getProcedureDescription(t) + ';'
    csv += t.dataProcedimento + ';'
    csv += t.dataAlta + ';'
    csv += (isPaidReport ? t.dataFechamentoRepasse : t.dataProtocolo) + ';'

    if (isPaidReport) {
      csv += t.dataPagamento + ';'
    } else if (isPendingReport) {
      csv += (t.classeDoTitulo ?? '') + ';'
      csv += (t.statusGlosaTituloReceber ?? '') + ';'
    }

    csv += t.valorRepasse + ';\n'
  })

  exportarCsv(csv, 'repasses')
}
